import cx from 'classnames';

import { Button } from '@motorway/mw-highway-code';

import { useVehicle, MessagingCard } from '@motorway/motorway-handshake-components';

import { snowplowCtaClick } from '../../helpers/snowplow';
import { useMessagingListHelpers, MESSAGING_LIST_FORMATTERS as MESSAGING_LIST_FORMATTERS_ORIGINAL } from './helpers/MessagingListHelpers';

import styles from './MessagingList.module.scss';

export const MESSAGING_LIST_FORMATTERS = MESSAGING_LIST_FORMATTERS_ORIGINAL;

type FormatterType = typeof MESSAGING_LIST_FORMATTERS[keyof typeof MESSAGING_LIST_FORMATTERS];

interface MessagingListProps {
  formatter: FormatterType;
  highlightRow?: number | null;
  motorwayPay?: boolean;
}

export const MessagingList = ({ formatter, motorwayPay = false, highlightRow = null }: MessagingListProps) => {
  const { vehicle: { enquiry } } = useVehicle();

  const { heading, data } = useMessagingListHelpers(formatter);

  const LABEL = 'Motorway Pay';
  const URL = `https://pro.motorway.co.uk/vehiclepayment/${enquiry.id}`;

  return (
    <div data-row={highlightRow} className={cx(styles.component, styles.messagingComponent)}>
      <MessagingCard
        action={(
          <>
            <ul>
              {
                data.map(([key, value]) => (
                  <li key={key} className={cx(styles.messagingListItem, styles.messagingListItemSpace)}>
                    <span>
                      {key}
                    </span>
                    <span>
                      {value}
                    </span>
                  </li>
                ),
                )
              }
            </ul>
            {motorwayPay && (
              <div className={styles.motorwayPay}>
                <Button
                  as="a"
                  fullWidth
                  href={URL}
                  label={LABEL}
                  showLabel
                  size="small"
                  target="_blank"
                  type="reset"
                  variant="secondary"
                  onClick={() => {
                    snowplowCtaClick({
                      button_label: LABEL,
                      name: 'mwpay_clicked',
                      url: URL,
                    });
                  }}
                />
              </div>
            )}
          </>
        )}
        {...{ heading }}
      />
    </div>
  );
};
